import { useCallback } from 'react';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import {
  ServiceCalculatorOfferRequest,
  ServiceCalculatorOfferResponse,
  VehicleMaintenanceWizard,
} from '../../../types/ServiceCalculatorTypes';
import { CenterType } from '../../../types/centerType';

export const useServiceCalculatorApi = () => {
  const getOfferFn = useCallback(async (request: ServiceCalculatorOfferRequest) => {
    try {
      const { data } = await apiClient.post<ServiceCalculatorOfferResponse>(ApiType.apimNafCenterApi, {
        url: ApiPaths[ApiType.apimNafCenterApi].serviceCalculator.offer,
        data: request,
      });

      return data;
    } catch {
      return undefined;
    }
  }, []);

  const getOfferWithPossibleEquipmentFn = useCallback(async (request: VehicleMaintenanceWizard) => {
    try {
      const { data } = await apiClient.post<ServiceCalculatorOfferResponse>(ApiType.apimNafCenterApi, {
        url: ApiPaths[ApiType.apimNafCenterApi].serviceCalculator.offerWithEq,
        data: request,
      });

      return data;
    } catch {
      return undefined;
    }
  }, []);

  const getOfferWithSelectedWorkProposalFn = useCallback(async (request: VehicleMaintenanceWizard) => {
    try {
      const { data } = await apiClient.post<ServiceCalculatorOfferResponse>(ApiType.apimNafCenterApi, {
        url: ApiPaths[ApiType.apimNafCenterApi].serviceCalculator.offerSelectedWorkProposal,
        data: request,
      });

      return data;
    } catch {
      return undefined;
    }
  }, []);

  const sendFeedbackFormFn = useCallback(
    async (email: string, comments: string, vehicleText: string, documentId: string) => {
      try {
        const formData = new FormData();
        const formDataValue = {
          fields: [
            { id: 'epost', value: email },
            { id: 'description', value: `Forespørsel fra service calc. <br> ${vehicleText} <br> ${comments}` },
            { id: 'documentId', value: documentId },
          ],
        };
        formData.append('fields', new Blob([JSON.stringify(formDataValue)], { type: 'application/json' }));

        const response = await apiClient.post(ApiType.apimFormApi, {
          url: ApiPaths[ApiType.apimFormApi].dynamicForm,
          data: formData,
        });

        return response.status < 400;
      } catch (e) {
        return false;
      }
    },
    [],
  );

  const getAvailableCenters = useCallback(async () => {
    try {
      const { data } = await apiClient.get<CenterType[]>(ApiType.apimNafNoApi, {
        url: ApiPaths[ApiType.apimNafNoApi].nafCenters,
        params: { productSlugs: 'servicekalkulator-elbil' },
      });

      return data;
    } catch {
      return undefined;
    }
  }, []);

  return {
    getOfferFn,
    getOfferWithPossibleEquipmentFn,
    getOfferWithSelectedWorkProposalFn,
    sendFeedbackFormFn,
    getAvailableCenters,
  };
};
